import axiosService from "./AxiosService.js";

const produitsService = {
  getProduitsAutocomplete(extraitNom) {
    return axiosService.get(`/produits/search?q=${extraitNom}`);
  },
  getProduits(recherche, page) {
    let url = `/produits/publies?q=${recherche}`;
    if (page) {
      url += `&pageIndex=${page}`;
    }
    return axiosService.get(url);
  },
  getProduitsDenomination(idDeno, page) {
    let url = `/denominations-communes/publies/${idDeno}/produits?`;
    if (page) {
      url += `&pageIndex=${page}`;
    }
    return axiosService.get(url);
  },
  getProduitsFournisseur(idFrn, page) {
    let url = `/fournisseurs/publies/${idFrn}/produits?`;
    if (page) {
      url += `&pageIndex=${page}`;
    }
    return axiosService.get(url);
  },
  getProduit(id) {
    return axiosService.get(`/produits/publies/${id}`);
  },
  getFournisseurProduit(id) {
    return axiosService.get(`/produits/publies/${id}/fournisseur`);
  },
  getReferencesProduit(id) {
    return axiosService.get(`/produits/publies/${id}/references`);
  },
  getIndicationsProduit(id) {
    return axiosService.get(`/produits/publies/${id}/indications`);
  },
  getDomainesProduit(id) {
    return axiosService.get(`/produits/publies/${id}/domaines`);
  },
  getElementsProduit(id) {
    return axiosService.get(`/produits/publies/${id}/elements`);
  },
  getSubstancesProduit(id) {
    return axiosService.get(`/produits/publies/${id}/substances`);
  },
  getSterilisationsProduit(id) {
    return axiosService.get(`/produits/publies/${id}/sterilisations`);
  },
  getDocumentsProduit(id) {
    return axiosService.get(`/produits/publies/${id}/documents`);
  },
  getImagesProduit(id) {
    return axiosService.get(`/produits/publies/${id}/images`);
  },
  getFicheDmPdf(id) {
    return axiosService.get(`/produits/ficheDm/${id}`, {
      responseType: "arraybuffer",
    });
  },
};
export default produitsService;
